module.exports = __webpack_public_path__ + "img/ic_exchange_actived.65886bbc.svg";